var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('router-view'),_c('audio',{attrs:{"src":"","id":"eventAudio"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }